import { useEffect } from 'react';
import { enableVadimTestMode } from '@gonfalon/dogfood-flags/dogfood-flags';
import { useThemeValue } from '@gonfalon/theme/useThemeValue';

// Side-effect import: registers the `.highlight-{light,dark,longhorn}-theme` CSS
// rules that this hook applies to `<body>`. Without it, the classname is set but
// no CSS variables are defined.
// oxlint-disable-next-line import/no-unassigned-import
import '../css/theme.css';

const THEME_CLASSES = ['highlight-light-theme', 'highlight-dark-theme', 'highlight-longhorn-theme'] as const;

const getThemeClassName = (theme: 'default' | 'dark', isLonghorn: boolean) => {
  if (isLonghorn) {
    return 'highlight-longhorn-theme';
  }
  return theme === 'dark' ? 'highlight-dark-theme' : 'highlight-light-theme';
};

/**
 * Applies the observability vanilla-extract theme class to document.body.
 * Required when rendering observability components (e.g. AgentInsightsPanel)
 * outside of ObservabilityRootLayout, since the Dialog portals to body
 * and needs the theme CSS variables to be defined there.
 */
export const useObservabilityTheme = () => {
  const theme = useThemeValue();
  const isLonghorn = enableVadimTestMode();

  useEffect(() => {
    const themeClass = getThemeClassName(theme, isLonghorn);
    document.body.classList.remove(...THEME_CLASSES);
    document.body.classList.add(themeClass);

    return () => {
      document.body.classList.remove(...THEME_CLASSES);
    };
  }, [theme, isLonghorn]);

  return { isLonghorn };
};
